"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_58_1_0 = void 0;
/**
 * Migrate to 58.1.0
 *
 * remove obsolete FixPosition property from Innenaufteilungselemente
 *
 */
const migration_58_1_0 = (json) => {
    if (json.IAs && json.IAs.length) {
        json.IAs.forEach((ia) => {
            if (ia.FixPosition != null) {
                delete ia.FixPosition;
            }
        });
    }
    return json;
};
exports.migration_58_1_0 = migration_58_1_0;
//# sourceMappingURL=migration_58_1_0.js.map